import React from 'react';
import { Link } from 'react-router-dom';
import Lockup from './ui/Lockup';

const Header = () => (
  <header className="bg-canvas">
    <div className="flex flex-wrap items-center justify-between gap-y-3 px-8 py-5 max-w-screen-2xl mx-auto">
      <Link to="/" className="flex items-center gap-2" aria-label="ARQNXS home">
        <Lockup className="h-7 w-auto text-ink" />
      </Link>
      <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate">
        <Link to="/dojipad" className="hover:text-navy">DojiPad</Link>
        <Link to="/dojipad-institutional" className="hover:text-navy">Institutional</Link>
        <Link to="/quantnexus" className="hover:text-navy">QNC</Link>
        <Link to="/licensing" className="hover:text-navy">Licensing</Link>
        <Link to="/work-with-us" className="hover:text-navy">Work with us</Link>
        <Link
          to="/contact"
          className="bg-navy text-white rounded-full px-5 py-2 text-xs"
        >
          Get in touch
        </Link>
      </nav>
    </div>
  </header>
);

export default Header;
